import { Link } from 'react-router-dom';

const formats = [
  { icon: 'ri-calendar-check-line', title: 'Тренинг для наставников', desc: 'Практическая программа развития навыков передачи опыта и развития сотрудников.' },
  { icon: 'ri-vip-crown-line', title: 'Тренинг для руководителей', desc: 'Развитие навыков наставничества как части управленческой роли руководителя.', to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley' },
  { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Несколько этапов обучения с практикой между встречами и закреплением навыков.' },
  { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Моделирование ситуаций обучения, обратной связи и развития сотрудников.' },
  { icon: 'ri-user-voice-line', title: 'Коучинг руководителей', desc: 'Индивидуальная работа с реальными ситуациями развития сотрудников.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение', desc: 'Разбор ситуаций наставников и руководителей после обучения.' },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Форматы развития навыков наставничества
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Формат подбирается под задачу компании, уровень наставников и масштаб программы развития
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors flex flex-col">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed flex-grow">{f.desc}</p>
              {f.to && (
                <Link
                  to={f.to}
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-3"
                >
                  Подробнее
                  <i className="ri-arrow-right-line"></i>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}